const HUBSPOT_PROVIDER_IMAGE_DEFAULT =
    'https://6509886.fs1.hubspotusercontent-na1.net/hubfs/6509886/raw_assets/public/VillageMedical/images/default-profile.svg';

const HUBSPOT_PROVIDER_SPECIALTY_DEFAULT = 'Primary Care';

export { HUBSPOT_PROVIDER_IMAGE_DEFAULT, HUBSPOT_PROVIDER_SPECIALTY_DEFAULT };
